import beckyPic from "@/public/images/artists/becky.png";
import { Artist } from "@/types/types";

export const becky = {
  id: "33",
  name: "Becky",
  image: beckyPic,
  description: `Meet "Becky," the enchanting indie songstress known for her airy vocals. With a voice that seems to effortlessly float through melodies, Becky brings a unique and ethereal quality to the indie music scene.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fbecky-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Indie", "Folk", "Airy"],
      secondary: ["Singer", "Spoken Word"],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 57,
        high: 71,
      },
    },
  },
} as const satisfies Artist;
